import { render, staticRenderFns } from "./FirstTab.vue?vue&type=template&id=2a2b08ec"
import script from "./FirstTab.vue?vue&type=script&lang=js"
export * from "./FirstTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports